export default "__VITE_ASSET__BMKxXEG$__"